import React, { useEffect, useRef } from 'react'

import Footer from '../Home/components/Footer/Footer'
import Meet from './component/Meet/Meet'

const About = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })
  }, [])

  const componentRef = useRef<HTMLDivElement>(null)

  return (
    <div id="about" ref={componentRef}>
      <Meet />
      <Footer isMinimized={false} />
    </div>
  )
}

export default About
